var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.selectItems,"placeholder":"Choose value","hide-details":"","outlined":"","dense":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }